declare global {
  interface Window {
    SITE_TRANSLATIONS: {
      [key: string]: string;
    };
  }
}

export default window.SITE_TRANSLATIONS;
